import React from 'react'
import {  FaTimes } from 'react-icons/fa'
import Howling from './Howling'
import {AudioFX} from '../AudioFX'


 const Task = ({ task, onDelete, onToggle }) => {
  return (

    //  <div className={`task ${task.reminder && 'reminder'}`}
    // onDoubleClick={() => onToggle(task.id)} >

<div className={ `task ${task.reminder ?  'reminder' : ' ' } `  }
    onDoubleClick={() => onToggle(task.id)} onMouseEnter = {() => Howling.play() } onMouseOver = {() => AudioFX[0].play() }>

        <h3 className="my-task">{task.id} 
        <FaTimes className='fa' onClick={ ( ) => onDelete (task.id)} />
        {/* <FaTimes className='fa' style={{ color: 'white' , cursor: 'pointer' } } onClick={ ( ) => onDelete (task.id)} /> */}
        </h3>
        <h3 className="my-task">{task.day}</h3>
        <h3 className="my-task">{task.text}  </h3>

    </div>
  )
}

export default Task


